import { LOG_LEVEL } from '@citylytics/logger/constants';

export const CONFIG = {
  CORE_API_URL: import.meta.env.VITE_CORE_API_URL,
  /** Everything while developing; in a built app only what somebody would act on. */
  LOG_LEVEL: import.meta.env.DEV ? LOG_LEVEL.DEBUG : LOG_LEVEL.WARN,
};
